import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

// Silence noisy debug logs and warnings in the browser console
// Keep errors visible for real issues
if (typeof window !== 'undefined' && typeof console !== 'undefined') {
	// No-op for logs and warnings
	// Note: Do not silence console.error to ensure real errors are still visible
	// This helps keep the console clean during demos and user sessions
	// while still surfacing actual problems.
	console.log = () => {};
	console.warn = () => {};
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);